import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

export interface ConditionExtractionFeedbackCriteria {
  btSpanId: string;
  suggestionRelevancy: number;
  erroneousSuggestions?: boolean;
  comment?: string | null;
}

export const useConditionExtractionFeedback = ({
  patientId,
  encounterId,
}: {
  patientId: string;
  encounterId: string;
}) => {
  return useApiMutation<void, ConditionExtractionFeedbackCriteria>({
    mutationOptions: {
      mutationKey: [
        "charting-feedback-condition-extraction",
        patientId,
        encounterId,
      ],
      mutationFn: async (payload: ConditionExtractionFeedbackCriteria) => {
        await axiosInstance.post(
          "/charting/ai-charting/feedback/questionnaire-condition-extraction",
          payload,
        );
      },
    },
  });
};
